import { useSelector } from 'react-redux'
import { useMyStrategyTierQuery } from '../queries/useMyStrategyTierQuery'

// @REVIEW - why is it stored on FE and not on BE?
const EDIT_TIERS = new Set(['full', 'roadmapAdmin'])

// Drop-in replacement for the old useIsReadonlyMode() -- same no-argument signature (resolves
// the current roadmap the same way the old hook resolved the user's global flag: internally, via
// redux, so nothing needs to be threaded through props). The difference is this is now
// per-roadmap instead of a single account-wide flag.
//
// Defaults to NOT readonly while the tier is still loading, rather than blocking optimistically --
// the backend is the real enforcement layer now (every write route actually checks this), so a
// user who briefly sees an enabled control before their real tier loads just gets a 403 if they
// click it in that window, which react-query's ~5min cache makes rare in practice. Defaulting the
// other way would flicker every edit affordance on every page load for the common case (most
// users have edit access).
export const useIsRoadmapReadonly = () => {
    // @ts-expect-error redux store is not typed properly
    const strategyId = useSelector((state) => state?.strategy?._id)
    const { data: tier, isLoading } = useMyStrategyTierQuery(strategyId)

    if (isLoading) return false
    return !EDIT_TIERS.has(tier ?? '')
}
